import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { AuthProvider } from './src/auth/authContext';
import { FanProvider } from './src/fanContext/fanContext';
import useCachedResources from './src/hooks/useCachedResources';
import useColorScheme from './src/hooks/useColorScheme';
import AppNavigator from './src/navigation';
import Amplify from 'aws-amplify';
import Honeybadger from '@honeybadger-io/js';
import Monitor from './src/lib/monitoring/Monitor';
import ErrorBoundary from '@honeybadger-io/react';
import config from './aws-exports';

Amplify.configure(config);
Monitor.configure();

// FIXME: REMOVE FAN PROVIDER ONCE APOLLO CLIENT IS IN
function App() {
  const isLoadingComplete = useCachedResources();
  const colorScheme = useColorScheme();

  if (!isLoadingComplete) {
    // Add a splash screen here
    return null;
  } else {
    return (
      <ErrorBoundary honeybadger={Honeybadger}>
        <AuthProvider>
          <FanProvider>
            <AppNavigator colorScheme={colorScheme} />
            <StatusBar />
          </FanProvider>
        </AuthProvider>
      </ErrorBoundary>
    );
  }
}

export default App;
